import {ModuleWithProviders, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LaEmptyComponent} from './la-empty.component';
import {LaImageModule} from '../image/la-image.module';
import {LaIconModule} from '../icon/la-icon.module';

@NgModule({
  imports: [
    CommonModule,
    LaImageModule,
    LaIconModule
  ],
  declarations: [LaEmptyComponent],
  exports: [LaEmptyComponent]
})
export class LaEmptyModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: LaEmptyModule,
      providers: []
    }
  }
}
